import React from 'react'

const Services = () => {
    return (
        <>
            <div className="choose-area py-20 mt-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="choose-content">
                                <div className="site-heading wow fadeInDown" data-wow-delay=".25s">
                                    <span className="site-title-tagline text-dark justify-content-start">
                                        <i className="flaticon-drive"></i> Why Choose Us
                                    </span>
                                    <h2 className="site-title text-dark mb-10"> We Give You <span>Dealer-Level </span> Access</h2>
                                    <p className="text-dark">
                                    We have the largest database of used, pre-owned, off-lease, insurance & salvage auction vehicles, with more than 150,000 live auction vehicles at any one moment.
                                    </p>
                                </div>
                                <div className="choose-img wow fadeInUp" data-wow-delay=".25s">
                                    <img src="/assets/img/choose/01.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="choose-content-wrapper wow fadeInRight" data-wow-delay=".25s">
                                <div className="row">
                                    <div className="col-md-6 col-lg-6 mt-lg-5">
                                        <div className="choose-item">
                                            <span className="choose-count">01</span>
                                            <div className="choose-item-icon">
                                                <i className="flaticon-car"></i>
                                            </div>
                                            <div className="choose-item-info">
                                                <h3>Official Representative</h3>
                                                <p>We are Copart Authorized representatives meaning you can buy with confidence and ease from over 300k vehicle inventory.</p>
                                            </div>
                                        </div>
                                        <div className="choose-item">
                                            <span className="choose-count">03</span>
                                            <div className="choose-item-icon">
                                                <i className="flaticon-chauffeur"></i>
                                            </div>
                                            <div className="choose-item-info">
                                                <h3>Live Bidding</h3>
                                                <p>Bid Live with us and transparently via Whatsapp Video or Skype if you prefer the hands-on approach.</p>
                                            </div>
                                        </div>
                                        <div className="choose-item mb-lg-0">
                                            <span className="choose-count">05</span>
                                            <div className="choose-item-icon">
                                                <i className="flaticon-drive-thru"></i>
                                            </div>
                                            <div className="choose-item-info">
                                                <h3>Low Transaction Fee</h3>
                                                <p>Our goal is to help you save money not just at the auction but all other charges as well. If you’re happy, we are happy.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6">
                                    <div className="choose-item mb-lg-0">
                                            <span className="choose-count">02</span>
                                            <div className="choose-item-icon">
                                                <i className="flaticon-drive-thru"></i>
                                            </div>
                                            <div className="choose-item-info">
                                                <h3>Experienced Brokers</h3>
                                                <p>With over 20 years cumulative wholesale/dealer only auction buying experience, our goal is to help you save money and avoid lemons.</p>
                                            </div>
                                        </div>
                                        <div className="choose-item mb-lg-0">
                                            <span className="choose-count">04</span>
                                            <div className="choose-item-icon">
                                                <i className="flaticon-online-payment"></i>
                                            </div>
                                            <div className="choose-item-info">
                                                <h3>Customer Support</h3>
                                                <p> Forget what you may have heard about the “stressful” process of buying cars from the US. Our client services is second to none as we employ a hands-on approach.</p>
                                            </div>
                                        </div>
                                        <div className="choose-item mb-lg-0">
                                            <span className="choose-count">06</span>
                                            <div className="choose-item-icon">
                                                <i className="flaticon-online-payment"></i>
                                            </div>
                                            <div className="choose-item-info">
                                                <h3>Export</h3>
                                                <p>We’re setup to assist you with shipping and export from the US, making us a one-stop shop to purchase your dream car without limits!.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Services